import React, { useEffect, useMemo } from 'react';
import css from './styles.module.scss';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import Box from '@material-ui/core/Box';
import { DealSummaryListDto } from '~/models/deals/DealsListItem.dto';
import { MusicApi } from '~/api/music.api';
import { notifyError } from '~/common/notifications';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { selectDetectSongChange } from '~/features/dashboard/store/selectors';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import { CardHeader } from '@material-ui/core';
import { DateFormat } from '~/common/date-format';
interface DealCardProps {
    deal: DealSummaryListDto;
    projectId: any;
    id: any;
    onLinkDeal: (data: any, type: any) => void;
}

export const SongDealCard: React.FC<DealCardProps> = ({ deal, projectId, id, onLinkDeal }) => {
    const [checked, setChecked] = React.useState(Boolean(deal.dealSongLinkFlag));

    let songChange = useSelector(selectDetectSongChange);

    useEffect(() => {
        if (songChange) {
            setChecked(true);
        }
    }, [songChange]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>, projectId: any, id: any, assetCode: any, deal: any) => {
        setChecked(event.target.checked);
        if (event.target.checked) {
            MusicApi.linkDeal(id, projectId, assetCode)
                .then(() => {
                    onLinkDeal(deal, 'link');
                })
                .catch(e => {
                    notifyError({
                        title: 'Error',
                        message: e.message || e.toString(),
                    });
                });
        } else {
            MusicApi.unlinkDeal(id, projectId, assetCode).then(() => {
                onLinkDeal(deal, 'unlink');
            });
        }
    };

    const image: string | undefined = useMemo(() => {
        return process.env.REACT_APP_ASSET + deal.contactImage || undefined;
    }, [deal]);

    return (
        <Card className={css.module} elevation={0}>
            <CardHeader
                className={css.header}
                avatar={
                    <AvatarGroup>
                        <Avatar variant="square" className={css.avatar} alt={deal.contractTitle} src={image} />
                    </AvatarGroup>
                }
                action={
                    <Checkbox
                        checked={checked}
                        onChange={event => handleChange(event, projectId, id, deal.assetCode, deal)}
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                        style={{ cursor: 'pointer' }}
                    />
                }
                title={deal.contractTitle}
            />
            <CardContent className={css.content}>
                <Box>
                    <Typography className={css.bold}>Type</Typography>
                    <Typography className={css.italic}>{deal.dealType}</Typography>
                </Box>
                {deal.contractStartDate && (
                    <Box>
                        <Typography className={css.bold}>Start Date</Typography>
                        <Typography className={css.italic}>{deal.contractStartDate && <DateFormat newDate={deal.contractStartDate} />}</Typography>
                    </Box>
                )}
                {!!deal.statementDate && (
                    <div className={css.infoBlock}>
                        <Typography className="releasedate">Statement Date</Typography>
                        <Typography className="gray-text"><DateFormat newDate={moment(deal.statementDate, 'YYYYMMDD')} /></Typography>
                    </div>
                )}
            </CardContent>
        </Card>
    );
};
